import React from "react";
import { Box, Container, Typography, Divider, Stack } from "@mui/material";

const headingFont = `"Bodoni Moda", serif`;

const RefundPolicyPage: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000000",
        color: "rgba(255,255,255,0.86)",
        minHeight: "100vh",
        py: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="md">
        {/* Page Title */}
        <Typography
          variant="h3"
          sx={{
            fontFamily: headingFont,
            fontWeight: 700,
            letterSpacing: ".06em",
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          Refund Policy
        </Typography>

        <Divider
          sx={{
            my: 5,
            borderColor: "rgba(255,255,255,0.12)",
          }}
        />

        <Stack spacing={4}>
          {/* Main policy intro */}
          <Box component="section">
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              We have a 30-day return policy, which means you have 30 days after
              receiving your item to request a return.
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              To be eligible for a return, your item must be in the same
              condition that you received it, unworn or unused, with tags, and
              in its original packaging. You’ll also need the receipt or proof
              of purchase.
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              To start a return, you can contact us at{" "}
              mianshahrukh085@gmail.com. Please note that returns will need to
              be sent to the following address: [INSERT RETURN ADDRESS].
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              If your return is accepted, we’ll send you a return shipping
              label, as well as instructions on how and where to send your
              package. Items sent back to us without first requesting a return
              will not be accepted.
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              You can always contact us for any return question at{" "}
              mianshahrukh085@gmail.com.
            </Typography>
          </Box>

          {/* Damages and issues */}
          <Box component="section">
            <Typography
              variant="h5"
              sx={{
                fontFamily: headingFont,
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              Damages and Issues
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              Please inspect your order upon reception and contact us
              immediately if the item is defective, damaged or if you receive
              the wrong item, so that we can evaluate the issue and make it
              right.
            </Typography>
          </Box>

          {/* Exceptions */}
          <Box component="section">
            <Typography
              variant="h5"
              sx={{
                fontFamily: headingFont,
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              Exceptions / Non-returnable Items
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              Certain types of items cannot be returned, like perishable goods
              (such as food, flowers, or plants), custom products (such as
              special orders or personalized items), and personal care goods
              (such as beauty products). We also do not accept returns for
              hazardous materials, flammable liquids, or gases. Please get in
              touch if you have questions or concerns about your specific item.
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              Unfortunately, we cannot accept returns on sale items or gift
              cards.
            </Typography>
          </Box>

          {/* Exchanges */}
          <Box component="section">
            <Typography
              variant="h5"
              sx={{
                fontFamily: headingFont,
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              Exchanges
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              The fastest way to ensure you get what you want is to return the
              item you have, and once the return is accepted, make a separate
              purchase for the new item.
            </Typography>
          </Box>

          {/* EU cooling off */}
          <Box component="section">
            <Typography
              variant="h5"
              sx={{
                fontFamily: headingFont,
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              European Union 14 Day Cooling Off Period
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              Notwithstanding the above, if the merchandise is being shipped
              into the European Union, you have the right to cancel or return
              your order within 14 days, for any reason and without a
              justification. As above, your item must be in the same condition
              that you received it, unworn or unused, with tags, and in its
              original packaging. You’ll also need the receipt or proof of
              purchase.
            </Typography>
          </Box>

          {/* Refunds */}
          <Box component="section">
            <Typography
              variant="h5"
              sx={{
                fontFamily: headingFont,
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              Refunds
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              We will notify you once we’ve received and inspected your return,
              and let you know if the refund was approved or not. If approved,
              you’ll be automatically refunded on your original payment method
              within 10 business days. Please remember it can take some time for
              your bank or credit card company to process and post the refund
              too.
            </Typography>
            <Typography paragraph sx={{ fontSize: ".98rem", lineHeight: 1.8 }}>
              If more than 15 business days have passed since we’ve approved
              your return, please contact us at mianshahrukh085@gmail.com.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default RefundPolicyPage;
